import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function GetClientList(
    activePage = 1, 
    pageSize = 10, 
    clientName = "",
    clientAddress = "",
    clientEmail = "",
    clientPhoneNumber = "",
    clientVAT = "",
    clientDomain = "",
    clientOib= ""
) {

    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let queryData = "?page=" + activePage + 
        "&size=" + pageSize + 
        "&clientName=" + clientName.trim() + 
        "&clientFullAddress=" + clientAddress.trim() +
        "&contactEmail=" + clientEmail.trim() +
        "&contactPhoneNumber=" + clientPhoneNumber.trim() +
        "&clientVatNumber=" + clientVAT.trim() +
        "&domain=" + clientDomain.trim() + 
        "&clientCountrySpecificVatNumber=" + clientOib.trim()

    return await resolve(
        axios( 'provider/client/list' + queryData, {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res.data)
        .catch(error => error.response.data),
        "Admin"
        );
}